// routes which require authentication
import { authRoutesAwards, guestRoutesAwards } from '@/router/routes-awards';

const authRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard-index" */ '../views/areas/dashboard/Index.vue'),
  },

  {
    path: '/conferences',
    name: 'Conferences',
    component: () => import(/* webpackChunkName: "conferences-index" */ '../views/areas/conferences/Index.vue'),
  },

  {
    path: '/conferences/apply',
    name: 'ConferencesApply',
    component: () => import(/* webpackChunkName: "conferences-apply" */ '../views/areas/conferences/Apply.vue'),
    meta: {
      breadcrumbParent: {
        path: '/conferences',
        text: 'My Applications',
      },
    },
  },

  {
    path: '/conferences/:id/reports/:reportId',
    name: 'ConferencesReport',
    component: () => import(/* webpackChunkName: "conferences-report" */ '../views/areas/reports/Edit.vue'),
    meta: {
      breadcrumbParent: {
        name: 'ConferencesCompleted',
        text: 'Conference - Summary',
      },
    },
  },

  {
    path: '/conferences/:id/reports/:reportId/details',
    name: 'ConferencesReportDetails',
    component: () => import(/* webpackChunkName: "conferences-report-details" */ '../views/areas/reports/Details.vue'),
    meta: {
      breadcrumbParent: {
        name: 'ConferencesCompleted',
        text: 'Conference - Summary',
      },
    },
  },

  {
    path: '/conferences/completed/:id',
    name: 'ConferencesCompleted',
    component: () => import(/* webpackChunkName: "conferences-apply" */ '../views/areas/conferences/Completed.vue'),
    meta: {
      breadcrumbParent: {
        path: '/conferences?section=historic',
        text: 'My Applications',
      },
    },
  },

  {
    path: '/approvals',
    name: 'Approvals',
    component: () => import(/* webpackChunkName: "approvals-index" */ '../views/areas/approvals/Index.vue'),
    meta: {
      breadcrumbParent: {
        path: '/dashboard',
        text: 'Dashboard',
      },
    },
  },

  {
    path: '/conferences/:conferenceId/approvals/:approvalId',
    name: 'ApprovalsEdit',
    component: () => import(/* webpackChunkName: "approvals-edit" */ '../views/areas/approvals/Edit.vue'),
    meta: {
      breadcrumbParent: {
        path: '/approvals',
        text: 'Approvals',
      },
    },
  },

  {
    path: '/account/edit-profile',
    name: 'ProfileEdit',
    component: () => import(/* webpackChunkName: "affiliates-edit" */ '../views/areas/account/EditProfile.vue'),
    meta: {
      breadcrumbParent: {
        path: '/dashboard',
        text: 'Dashboard',
      },
    },
  },

  {
    path: '/post-register',
    name: 'PostRegister',
    component: () => import(/* webpackChunkName: "post-register" */ '../views/areas/account/PostRegister.vue'),
  },
];

// routes which don't require authentication
const guestRoutes = [
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: function maintenancePageRoute() {
      return import(/* webpackChunkName: "maintenance-page" */ '../views/pages/Maintenance.vue');
    },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home-page" */ '../views/pages/Home.vue'),
  },

  {
    path: '/guest',
    name: 'Guest',
    component: () => import(/* webpackChunkName: "guest-page" */ '../views/pages/Guest.vue'),
  },

  {
    path: '/certificate',
    name: 'Certificate',
    component: () => import(/* webpackChunkName: "guest-page" */ '../views/pages/Certificate.vue'),
  },

  {
    path: '/affiliates',
    name: 'Affiliates',
    component: () => import(/* webpackChunkName: "affiliates-index" */ '../views/areas/affiliates/Index.vue'),
  },

  {
    path: '/areas',
    name: 'TechnicalAreas',
    component: () => import(/* webpackChunkName: "technical-areas-index" */ '../views/areas/technical-areas/Index.vue'),
  },

  {
    path: '/areas/edit',
    name: 'TechnicalAreasEdit',
    component: () => import(/* webpackChunkName: "technical-areas-edit" */ '../views/areas/technical-areas/Edit.vue'),
    meta: {
      breadcrumbParent: {
        path: '/areas',
        text: 'IFAC Technical Areas',
      },
    },
  },

  {
    path: '/areas/edit-keywords',
    name: 'TechnicalAreasEditKeywords',
    component: () => import(/* webpackChunkName: "technical-areas-edit-keywords" */ '../views/areas/technical-areas/EditKeywords.vue'),
    meta: {
      breadcrumbParent: {
        path: '/areas',
        text: 'IFAC Technical Areas',
      },
    },
  },

  {
    path: '/areas/validate',
    name: 'TechnicalAreasValidate',
    component: () => import(/* webpackChunkName: "technical-areas-validate" */ '../views/areas/technical-areas/Validate.vue'),
    meta: {
      breadcrumbParent: {
        path: '/areas',
        text: 'IFAC Technical Areas',
      },
    },
  },

  {
    path: '/affiliates/officials',
    name: 'IFAC Officials',
    component: () => import(/* webpackChunkName: "affiliates-index" */ '../views/areas/affiliates/Officials.vue'),
  },

  {
    path: '/affiliates/officials/nmo/:countryCode',
    name: 'NationalMemberOrganizationView',
    component: () => import(/* webpackChunkName: "member-organization-view" */ '../views/areas/affiliates/MemberOrganizationView.vue'),
    props: { organizationType: 'nmo' },
    meta: {
      breadcrumbParent: {
        name: 'IFAC Officials',
        text: 'IFAC Officials',
      },
    },
  },

  {
    path: '/affiliates/officials/amo/:countryCode',
    name: 'AssociateMemberOrganizationView',
    component: () => import(/* webpackChunkName: "member-organization-view" */ '../views/areas/affiliates/MemberOrganizationView.vue'),
    props: { organizationType: 'amo' },
    meta: {
      breadcrumbParent: {
        name: 'IFAC Officials',
        text: 'IFAC Officials',
      },
    },
  },

  {
    path: '/affiliates/:id',
    name: 'AffiliatesView',
    component: () => import(/* webpackChunkName: "affiliates-view" */ '../views/areas/affiliates/View.vue'),
    meta: {
      breadcrumbParent: {
        name: 'Affiliates',
        text: 'Affiliates',
      },
    },
  },

  {
    path: '/conferences/all',
    name: 'ConferencesAll',
    component: () => import(/* webpackChunkName: "conferences-all" */ '../views/areas/conferences/All.vue'),
  },

  {
    path: '/conferences/:year',
    name: 'ConferencesPublicDisplay',
    component: () => import(/* webpackChunkName: "conferences-display" */ '../views/areas/conferences/Display.vue'),
    props: (route) => ({
      year: route.params.year,
    }),
  },
];

export default function buildRoutes({ authGuard, guestGuard }) {
  return [
    ...authGuard(authRoutes),
    ...authGuard(authRoutesAwards),
    ...guestGuard(guestRoutesAwards),
    ...guestGuard(guestRoutes),
  ];
}
